import React, { createContext, useContext, useEffect, useState } from "react";

const ProjectContext = createContext();

export const ProjectProvider = ({ children }) => {
  // Load from localStorage initially
  const [selectedProject, setSelectedProject] = useState(() => {
    const saved = localStorage.getItem("selectedProject");
    return saved ? JSON.parse(saved) : null;
  });

  // Save whenever project changes
  useEffect(() => {
    if (selectedProject) {
      localStorage.setItem(
        "selectedProject",
        JSON.stringify(selectedProject)
      );
    }
  }, [selectedProject]);

  return (
    <ProjectContext.Provider
      value={{
        selectedProject,
        setSelectedProject,
      }}
    >
      {children}
    </ProjectContext.Provider>
  );
};

export const useProject = () => useContext(ProjectContext);